export const governmentSupportEnum = [
    {
        name: "Incentivos fiscais à P&D e inovação tecnológica, conforme previsto na Lei nº 8.661 e Cap. III da Lei nº11.196",
        value: "taxIncentivePnD"
    },
    {
        name: "Incentivo fiscal Lei de Informática, conforme previsto na Lei nº 10.664, Lei nº 11.077",
        value: "taxIncentiveCompLaw"
    },
    {
        name: "Subvenções econômicas à P&D e às inserções de pesquisadores, conforme previsto na Lei nº 10.973 e Art. 21 da Lei nº 11.196",
        value: "economicGrantsPnD"
    },
    {
        name: "Financiamento a projetos de P&D e inovação tecnológica EM parceria com universidades ou institutos de pesquisa",
        value: "inPartnership"
    },
    {
        name: "Financiamento a projetos de P&D e inovação tecnológica SEM parceria com universidades ou institutos de pesquisa",
        value: "noPartnership"
    },
    {
        name: "Financiamento exclusivo para a compra de máquinas e equipamentos utilizados para inovar",
        value: "exclusiveFinancing"
    },
    {
        name: "Bolsas oferecidas por fundações de amparo à pesquisa RHAE/CNPq para pesquisadores em empresas",
        value: "scholarshipsOffered"
    },
    {
        name: "Aporte de Venture capital baseado em recursos públicos",
        value: "ventureContribution"
    },
    {
        name: "Outros (especificar)",
        value: "others"
    },
];